import {Component, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SalesService} from 'src/app/services/sales.service';
import {phoneValidator} from 'src/app/validators/form-validator';
import {NgIf} from '@angular/common';
import {environment} from 'src/environments/environment';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {RecaptchaModule, RecaptchaFormsModule} from 'ng-recaptcha-2';
import {NgxMaskDirective} from 'ngx-mask';

@Component({
  selector: 'app-invite-a-friend',
  templateUrl: './invite-a-friend.component.html',
  styleUrls: ['./invite-a-friend.component.scss'],
  imports: [NgIf, FormsModule, ReactiveFormsModule, NgxMaskDirective, RecaptchaModule, RecaptchaFormsModule]
})

export class InviteAFriendComponent {
  private _googleAnalyticsService = inject(GoogleAnalyticsService);
  private _salesService = inject(SalesService);
  private _destroyRef = inject(DestroyRef);
  public ngbActiveModal = inject(NgbActiveModal);

  public token: string = '';
  public url: string = '';
  public showCaptchaError: boolean = false;
  public successMessage: boolean = false;
  public captcha: string = environment.publicCaptchaKey;
  public sendInviteForm: FormGroup = new FormGroup({
    phoneNumber: new FormControl('', [Validators.required, phoneValidator])
  });
  public office: any = {};

  public sendInvitation(): void {
    this.showCaptchaError = false;
    if (this.token !== '') {
      this.url =  location.origin ;
      const phoneNum = this.sendInviteForm.controls['phoneNumber'].value;
      const captchaRes = this.token;
      this._salesService.sendInvitation(phoneNum, captchaRes).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(()=> {
        this.successMessage = true;
        this._googleAnalyticsService.sendKeyEvent('invite_friend', {
          timestamp: new Date().toISOString()
        });
      });
    } else {
      this.showCaptchaError = true;
    }
  }
}
